import React from "react";
import {css} from "@emotion/react";

import {Loader} from "@pg-design/loader-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {LeadModal} from "../../lead/components/lead_modal/LeadModal";
import {useMyOffersFavourites} from "../../my_offers/hooks/use_my_offers_favourites";
import {AskForAllModal} from "../components/AskForAllModal/AskForAllModal";
import {ComparisonTool} from "../components/ComparisonTool";
import {MyPlaceModal} from "../components/ComparisonToolTable/MyPlaceModal";
import {NoItemsToCompare} from "../components/NoItemsToCompare";
import {PropertyPlanModal} from "../components/PropertyPlanModal/PropertyPlanModal";
import {ComparisonToolContextProvider, useComparisonToolContext} from "../contexts/comparison_tool_context";
import {comparisonToolAnalytics, ComparisonToolGTMTableAction} from "../utils/comparison_tool_analytics";

const rpLogo = require("../../app/images/rp_logo_340x86.png");

const ComparisonToolViewNC = () => {
    const {favouriteProperties, loaded} = useMyOffersFavourites(true);
    const {askForAllModalOpened, setAskForAllModalOpened} = useComparisonToolContext();

    if (favouriteProperties.length === 0 && loaded) {
        return <NoItemsToCompare />;
    }

    return (
        <article css={comparisonToolViewStyle}>
            {!loaded ? (
                <div css={pageLoaderStyle}>
                    <Loader size="lg" />
                </div>
            ) : (
                <ComparisonTool
                    analyticEvents={{
                        onLeftArrowClick: () => comparisonToolAnalytics.gtm.tableEvent(ComparisonToolGTMTableAction.LEFT_ARROW_CLICK),
                        onRightArrowClick: () => comparisonToolAnalytics.gtm.tableEvent(ComparisonToolGTMTableAction.RIGHT_ARROW_CLICK)
                    }}
                    onBackClick={() => window.location.replace(rpAppLink.myList())}
                />
            )}

            <MyPlaceModal />

            <PropertyPlanModal />

            {askForAllModalOpened && (
                <AskForAllModal
                    isOpened={askForAllModalOpened}
                    closeModal={() => {
                        setAskForAllModalOpened(false);
                    }}
                />
            )}
            <LeadModal />
        </article>
    );
};

export const ComparisonToolView = () => (
    <ComparisonToolContextProvider>
        <ComparisonToolViewNC />
    </ComparisonToolContextProvider>
);

const pageLoaderStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 600px;
`;

const comparisonToolViewStyle = css`
    background: #fff;

    @media print {
        transform: scale(0.65) translate(-25%, -25%);
        position: relative;
        width: 400mm;
        height: 190mm;
        margin: 0;
        display: grid; // Firefox fix: in order to prevent component from being moved to next page
        grid-template-columns: repeat(1, 1fr);

        &:before {
            content: url(${rpLogo});
            z-index: 2;
            position: absolute;
            right: 0;
            top: 0;
            transform: scale(0.5) translate(50%, -50%);
        }

        @page {
            size: A4 landscape;
        }
    }
`;
import React from "react";
import {css} from "@emotion/react";

import {Loader} from "@pg-design/loader-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {LeadModal} from "../../lead/components/lead_modal/LeadModal";
import {useMyOffersFavourites} from "../../my_offers/hooks/use_my_offers_favourites";
import {AskForAllModal} from "../components/AskForAllModal/AskForAllModal";
import {ComparisonTool} from "../components/ComparisonTool";
import {MyPlaceModal} from "../components/ComparisonToolTable/MyPlaceModal";
import {NoItemsToCompare} from "../components/NoItemsToCompare";
import {PropertyPlanModal} from "../components/PropertyPlanModal/PropertyPlanModal";
import {ComparisonToolContextProvider, useComparisonToolContext} from "../contexts/comparison_tool_context";
import {comparisonToolAnalytics, ComparisonToolGTMTableAction} from "../utils/comparison_tool_analytics";

const rpLogo = require("../../app/images/rp_logo_340x86.png");

const ComparisonToolViewNC = () => {
    const {favouriteProperties, loaded} = useMyOffersFavourites(true);
    const {askForAllModalOpened, setAskForAllModalOpened} = useComparisonToolContext();

    if (favouriteProperties.length === 0 && loaded) {
        return <NoItemsToCompare />;
    }

    return (
        <article css={comparisonToolViewStyle}>
            {!loaded ? (
                <div css={pageLoaderStyle}>
                    <Loader size="lg" />
                </div>
            ) : (
                <ComparisonTool
                    analyticEvents={{
                        onLeftArrowClick: () => comparisonToolAnalytics.gtm.tableEvent(ComparisonToolGTMTableAction.LEFT_ARROW_CLICK),
                        onRightArrowClick: () => comparisonToolAnalytics.gtm.tableEvent(ComparisonToolGTMTableAction.RIGHT_ARROW_CLICK)
                    }}
                    onBackClick={() => window.location.replace(rpAppLink.myList())}
                />
            )}

            <MyPlaceModal />

            <PropertyPlanModal />

            {askForAllModalOpened && (
                <AskForAllModal
                    isOpened={askForAllModalOpened}
                    closeModal={() => {
                        setAskForAllModalOpened(false);
                    }}
                />
            )}
            <LeadModal />
        </article>
    );
};

export const ComparisonToolView = () => (
    <ComparisonToolContextProvider>
        <ComparisonToolViewNC />
    </ComparisonToolContextProvider>
);

const pageLoaderStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 600px;
`;

const comparisonToolViewStyle = css`
    background: #fff;

    @media print {
        transform: scale(0.65) translate(-25%, -25%);
        position: relative;
        width: 400mm;
        height: 190mm;
        margin: 0;
        display: grid; // Firefox fix: in order to prevent component from being moved to next page
        grid-template-columns: repeat(1, 1fr);

        &:before {
            content: url(${rpLogo});
            z-index: 2;
            position: absolute;
            right: 0;
            top: 0;
            transform: scale(0.5) translate(50%, -50%);
        }

        @page {
            size: A4 landscape;
        }
    }
`;
